
import { IonModal, IonPopover } from "@ionic/react";
import { useLayoutEffect, useRef } from "react";
import { useIsMobile } from "../../../Responsive";
import { ListProps } from "../../types";


import { RouteParams } from "../../../NamedRoutes";
import listStyle from "../../List.module.scss";

/* function maxScreenHeight(height: number, y: number, side: PositionSide, margin: number = 10): number
{
    return (side === "top" ? (height - y) : y) - margin;
}
function pxToPercent(childSize: number, parentSize: number): number
{
    return Math.round((childSize / parentSize) * 100);
}
 */

export type PresentOptions = { id: any, event: any, routeParams: RouteParams; };

type SettingsMenuProps = Pick<ListProps, | "ableSwitchContextDirection" | "onPopupResize" | "onMenu">
    & { flipDirectionPercent: number, presentOption: PresentOptions | null, onDismiss: () => void; };


const modalBreakpoint = .6;

export const ContextMenu: React.FC<SettingsMenuProps> = ({
    onMenu,
    flipDirectionPercent,
    presentOption,
    onDismiss
}) =>
{
    const dismissOptions = () =>
    {
        onDismiss();
    };
    const contextMenu = onMenu && presentOption ? onMenu(presentOption.id, dismissOptions, null, presentOption.routeParams) : null;

    const mobileView = useIsMobile();
    const ContextMenuElement = mobileView ? IonModal : IonPopover;

    const clickedOnYPosition = useRef<number>(0);
    const containerHeight = useRef<number>(0);

    useLayoutEffect(() =>
    {
        if (mobileView) return;
        if (presentOption) {
            if (!contextMenu) return;

            const { event } = presentOption;
            const { clientY, view } = event!.nativeEvent as PointerEvent;

            clickedOnYPosition.current = clientY;

            const screenHeight = view?.innerHeight || 0;
            containerHeight.current = screenHeight;
        }

    }, [contextMenu, flipDirectionPercent, mobileView, presentOption]);


    return <ContextMenuElement
        reference="event"
        //side={contextDirection.current}
        side="bottom"
        alignment="end"
        size="auto"
        event={presentOption?.event}
        initialBreakpoint={mobileView ? modalBreakpoint : undefined}
        className={mobileView ? listStyle.menu : ''}
        isOpen={Boolean(contextMenu)}
        onIonModalDidPresent={(e) =>
        {
            const modal = e.target;

            const { children } = modal;
            if (!children.length) return;
            const popup = children[0] as HTMLIonPopoverElement;
            if (!popup.children.length) return;

            popup.setAttribute("style", `justify-content: start; !important`);

            const [header, content] = popup.children;

            const maxHeight = ((modal.clientHeight / 100) * (modalBreakpoint * 100)) - header.clientHeight;

            if (content) {
                content.setAttribute("style", `max-height:${maxHeight}px !important`);
            }
        }}
        onIonPopoverDidPresent={(e) =>
        {
            /*  if (mobileView) return;
             const popover = e.target as HTMLIonPopoverElement;

             const { children } = popover;
             if (!children.length) return;
             const popup = children[0] as HTMLIonPopoverElement;
             if (!popup.children.length) return;

             const [header, content] = popup.children;
             let offsetY = "unset";
             let maxHeight = "0px";

             const spaceContentAndScreen = 20;
             const spaceBetweenPopupAndMouse = 60;


             const switchDirectionAtPx = (containerHeight.current / 2) + (containerHeight.current / 4);

             if (clickedOnYPosition.current > switchDirectionAtPx) {

                 const spaceToTop = clickedOnYPosition.current;

                 const spaceBetweenPopupAndTop = (spaceContentAndScreen + (spaceBetweenPopupAndMouse) + header.clientHeight);
                 const popupContentHeight = spaceToTop - spaceBetweenPopupAndTop;
                 let height = popupContentHeight;


                 if (popupContentHeight > popup.clientHeight) {

                     height = popup.clientHeight;

                 }
                 maxHeight = `${height}px`;

                 offsetY = `-${height + (spaceBetweenPopupAndMouse)}px`;

             } else {
                 const spaceToBottom = containerHeight.current - clickedOnYPosition.current;

                 offsetY = "unset";
                 maxHeight = `${spaceToBottom - (spaceContentAndScreen + header.clientHeight)}px`;
             }
             popover.setAttribute("style", `--offset-y:${offsetY}`);
             content.setAttribute("style", `max-height:${maxHeight} !important`); */

        }}
        onDidDismiss={dismissOptions}
        keepContentsMounted={true}
    >
        {contextMenu}
    </ContextMenuElement>;
};
